import RemoveReadingGoalModal from './RemoveReadingGoalModal'

export default RemoveReadingGoalModal
